export const connectivityState = {
  isConnectedToInternet: false,
};
